var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"150px"}},[_c('vue-loading',{attrs:{"type":"bars","color":"#08A681","size":{ width: '60px', height: '60px' }}}),_c('p',{staticClass:"loading"},[_vm._v("请稍等，数据正在加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }